import { render, staticRenderFns } from "./FallbackLinks.vue?vue&type=template&id=7984b5ae&scoped=true&"
import script from "./FallbackLinks.vue?vue&type=script&lang=js&"
export * from "./FallbackLinks.vue?vue&type=script&lang=js&"
import style0 from "./FallbackLinks.vue?vue&type=style&index=0&id=7984b5ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7984b5ae",
  null
  
)

export default component.exports